<template>
  <div>
    <v-card>
      <v-toolbar card color="white">
        <v-text-field
          flat
          solo
          hide-details
          prepend-icon="search"
          placeholder="Tìm trên danh sách"
          v-model="searchText"
        ></v-text-field>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="exportToExcel()">
            <v-icon>save_alt</v-icon>
          </v-btn>
          <span>Tải về danh sách</span>
        </v-tooltip>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <v-data-table
          item-key="id"
          :headers="headers"
          :search="searchText"
          :items="datasource"
          :rows-per-page-items="[10,20,50,100]"
          :loading="isLoading"
        >
          <template slot="items" slot-scope="props">
            <td v-for="(h, index) in headers" :key="index">{{ props.item[h.value]}}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    datasource: {
      type: Array,
      default: []
    },
    headers: {
      type: Array,
      default: []
    },
    exportFilename: {
      type: String,
      default: 'file'
    }
  },
  data () {
    return {
      searchText: ''
    };
  },
  methods: {
    exportToExcel () {
      if (this.datasource.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }
      let data = [];
      this.datasource.map((item, index) => {
        let a = this.datasource.filter(
          b => b[this.headers[0].value] === index + 1
        )[0];
        if (a) {
          data.push(a);
        }
        return 0;
      });
      let sheet = XLSX.utils.json_to_sheet(data);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'Export');
      XLSX.writeFile(wb, `${this.exportFilename}.xlsx`);
    }
  }
};
</script>
<style scoped>
.v-card__text {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/reporting/components/List.vue